export default __webpack_public_path__ + "static/bg-15fc2d5137923ba1115e861d0eb08f61.png";